exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container {\n    /*esto es para que el div se expanda*/\n    width: 100%;\n    margin: 0 auto;\n    min-height: calc(100vh - 0px);\n    background: url(/assets/img/login.jpg) no-repeat center center fixed;   \n    background-size: cover;  \n    overflow: hidden;\n    text-align: center;\n    padding-left: 0px;\n    padding-right: 0px;\n}\n.transparent {\n    margin-top: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    min-height: calc(100vh - 0px);\n}\n.transparent:nth-child(1) {\n    padding-top: 10%;\n}\n.jumbotron {\n    margin: 0 auto;\n    padding: 2%; \n    background-color: rgba(255,255,255, 0.8);   \n    display: block;\n    width: 50%;\n}\n.jumbotron:nth-child(2) {\n    margin-top: 1%;\n}\n.form-group {\n    margin: 0 auto;\n    display: block;\n    text-align: center;\n}\n.form-control {\n    border: 1px solid#d1251f;\n    border-radius: 0;\n    color:#000000 !important;\n}\n.btn-center {\n    margin-top: 1%;\n    background-color: #d1251f; \n    color: white;\n    border-radius: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/components/auth.component.css
// module id = 1008
// module chunks = 0